import { httpClient } from '../httpClient/httpClient';

export const organizationsApi = {
  updateLogo: (organizationId: number, fileId: number) =>
    httpClient.put(`organizations/${organizationId}/logoimage/${fileId}`),
  deleteLogo: (organizationId: number) =>
    httpClient.delete(`organizations/${organizationId}/logoimage`),
};
